// Audience/lens helpers for the 3-access model: admin · investor · manufacturer.
import { NDA_VERSION } from "./data/nda";

const KEY = `anx_access_v${NDA_VERSION}`;
const VIEW_KEY = "anx_view_as";

export function getAccessRecord() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { return null; }
}

// The audience granted at NDA unlock (or "admin" for a signed-in owner/staff session).
export function getStoredAudience() {
  const r = getAccessRecord();
  if (!r) return null;
  if (r.via === "login") return "admin";
  return r.audience || "investor";
}

export function isAdmin() { return getStoredAudience() === "admin"; }

// Admin "View as" preview override (session-scoped).
export function getViewAs() { try { return sessionStorage.getItem(VIEW_KEY) || null; } catch (e) { return null; } }
export function setViewAs(a) {
  try { if (a) sessionStorage.setItem(VIEW_KEY, a); else sessionStorage.removeItem(VIEW_KEY); } catch (e) { /* noop */ }
}
export function clearViewAs() { setViewAs(null); }

// What the current session should effectively see.
export function effectiveAudience() {
  const base = getStoredAudience();
  if (base === "admin") return getViewAs() || "admin";
  return base;
}

export function canSee(allow) {
  const eff = effectiveAudience();
  if (eff === "admin") return true;
  return Array.isArray(allow) && allow.includes(eff);
}
